import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Vehicle } from '../state-man/models/vehicle.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }
 
  public async getAll () : Promise<Vehicle[] | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'vehicle/active/')  
      return (ret && Array.isArray(ret)) ? Vehicle.buildMany(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + 'vehicle/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
  
}
